import {usePasswordValidationMessages} from '@amblique/king-living/app/hooks/use-password-validation-messages';

/**
 * Loads the login password error message from BM site preferences via Custom SCAPI.
 * Falls back to i18n when the BM value is missing.
 *
 * @returns {{message: string, isLoading: boolean}}
 */
export const useLoginPasswordErrorMessage = () => usePasswordValidationMessages('login');
